import {setIsAuthenticated, setIsLoading, setUsuarioPerfil} from '../reduxstore/actions/action-creators';
import {lazyInject, TYPES} from '../utils/inversify-config';
import {Store} from 'react-redux';
import MeepoState from '../reduxstore/meepo-state';
import FirebaseClient from './firebase';
import {ACCESS_TOKEN} from '../utils/constants';
import {IUser} from '../utils/models';
import {injectable} from 'inversify';
import {error} from '../utils/notification-actions';
import MeepoServiceClient from './meepo-client';
import * as qs from 'query-string';
import * as moment from 'moment';

@injectable()
export class UserClient {

    @lazyInject(TYPES.MEEPO_SERVICE)
    public apiClient: MeepoServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public store: Store<MeepoState>;

    @lazyInject(TYPES.FIREBASE)
    public firebase: FirebaseClient;

    public async autenticar() {
        try {
            const user = await this.firebase.getApp().auth().currentUser;
            if (user != null) {
                await user.getIdToken().then((idToken) => {
                    localStorage.setItem(ACCESS_TOKEN, idToken);
                });
                const profile = await this.getProfile(user.email);
                if (profile && profile.roles) {
                    this.store.dispatch(setUsuarioPerfil(profile));
                    this.store.dispatch(setIsAuthenticated(true));
                    let fecha;
                    if(window.location.search){
                        fecha = qs.parse(window.location.search).fecha
                    }
                    this.apiClient.cargarResumenesDiariosXRuta(fecha ? fecha : moment().format('YYYY-MM-DD'));
                }
            } else {
                this.store.dispatch(setIsAuthenticated(false));
            }
        } catch (e) {
            this.store.dispatch(error('Error', 'El usuario no ha sido aprobado'));
        } finally {
            this.store.dispatch(setIsLoading(false));
        }
    }

    public async getProfile(email: string): Promise<IUser> {
        return new Promise<any>((resolve, reject) => {
            const usuarioRef = this.firebase.getDb().collection(`usuarios`).doc(email);
            usuarioRef.get().then((doc) => {
                if (doc.exists) {
                    resolve(doc.data());
                } else {
                    reject();
                }
            });
        });
    }

}

export default UserClient;


// WEBPACK FOOTER //
// ./src/middleware/user-client.ts